import { AxiosApi as BaseAxiosApi } from '@rhim/requests';
import { assert, isDefined } from '@rhim/utils';
import { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';

/**
 * APO Axios API class.
 * Extends the base class to add an extra header for the LogRocket session URL.
 */
export class AxiosApi extends BaseAxiosApi {
  /**
   * Log Rocket Session URL.
   */
  private sessionURL: string | null = null;

  /**
   * Initializes the optional LogRocket session URL after construction.
   * @param getSession Getter fn.
   */
  async initializeSessionUrl(getSession: () => Promise<string | null>): Promise<void> {
    this.sessionURL = await getSession();
  }

  /**
   * Sets the Log RocketSession URL to request headers.
   * @param config
   * @returns the new config.
   */
  protected setHeaders(config: AxiosRequestConfig): InternalAxiosRequestConfig {
    const requestConfig: InternalAxiosRequestConfig = super.setHeaders(config);

    if (isDefined(this.sessionURL)) {
      assert(isDefined(requestConfig.headers), 'requestConfig headers undefined');
      requestConfig.headers['X-LogRocket-URL'] = this.sessionURL;
    }

    return requestConfig;
  }
}
